<div style="display: flex; flex-direction: column; flex: 1">
  <div class="header-color" style="display: flex; flex-direction: row;">
    <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;" translate>
      Attendance
    </div>
    <div style="display: flex; flex-direction: column; flex: 1; padding-right: 5px; justify-content: center; align-items: flex-end">
        <button mat-stroked-button class="mat-card-button" (click)="viewAllClick()"><span translate>Go To Attendance</span></button>
    </div>
  </div>
  <div style="display: flex; flex-direction: column; flex: 1">
    <div style="display: flex; flex-direction: column; flex: 1;">

        <div class="robotoMedium" style="display: flex; flex-direction: row; font-size: 12pt; margin-left: 10px; margin-top: 5px;" translate>Today</div>

        <div style="display: flex; flex-direction: row; justify-content: center; padding: 10px" *ngIf="studentAttendance.length == 0" translate>No tardies or absences today</div>

    </div>
    <table *ngIf="studentAttendance.length > 0" mat-table [dataSource]="studentAttendance" style="width: 100%">

      <!-- Class Column -->
      <ng-container matColumnDef="Class">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black" translate> Class</th>
        <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;"> {{attendanceRecord.Class}} </td>
      </ng-container>

      <!-- Meets Column -->
      <ng-container matColumnDef="Meets">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black" translate> Meets</th>
        <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;" [innerHTML]="attendanceRecord.Meets"></td>
      </ng-container>

      <!-- Marked Column -->
      <ng-container matColumnDef="Marked">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black" translate> Marked</th>
        <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;"> {{attendanceRecord.Marked}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div class="robotoMedium" style="display: flex; flex-direction: row; font-size: 12pt; margin-left: 10px; margin-top: 5px; margin-bottom: 5px;" translate>
      Year-To-Date
    </div>
    <div style="display:flex; flex-direction: row; margin-left: 5px; padding: 5px">
      <div style="display: flex; flex-direction: column; flex: 1.5;padding-left: 5px">
        <div  style="display: flex; flex: .80;white-space: pre;">
            {{DaysPresent |number:'2.2-2'}} <span translate>of</span> {{TotalDays |number:'2.2-2'}} <span translate>Days</span>
          ({{((DaysPresent/TotalDays)*100)|number:'2.2-2'}} %)
        </div>
        <div style="display: flex; flex: .80; white-space: pre">
          {{HoursPresent |number:'2.2-2'}} <span translate>of</span> {{TotalHours |number:'2.2-2'}} <span translate>Hours</span>
          ({{((HoursPresent/TotalHours)*100)|number:'2.2-2'}} %)
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row; padding: 5px">
    <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; margin-left: 10px">
      <button mat-stroked-button class="mat-card-close-button" (click)="closeClick()"><span translate>Close</span></button>
    </div>
  </div>
</div>
